import Flickity from 'flickity';
require('flickity-fade');

const norientCarousels = document.querySelectorAll('.carousel-section');

norientCarousels.forEach((norientCarousel) => {
	const carousel = norientCarousel.querySelector('.main-carousel');

	// Create carousel
	const flickity = new Flickity(carousel, {
		autoPlay: true,
		// cellAlign: 'left',
		draggable: true,
		prevNextButtons: true,
		pageDots: true,
		fade: false,
		imagesLoaded: true,
		wrapAround: true,
		on: {
			change: () => {},
		},
	});
});
